import { SortData } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ECircuitFilter, EExchangeType, EPeriod, EPricePeriod, EVolumePeriod, } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
import { ESortOrder } from "@domains/utils/sort";
import { MarketTabsConstants, marketsRoute, viewInDetail, } from "../Common/constant";
export const activeSectionOptions = {
    threshold: 0,
    delay: 1000,
};
export const indiceslist = [
    { title: "Nifty 50", value: "Nifty 50" },
    { title: "Nifty Next 50", value: "Nifty Next 50" },
    { title: "Nifty 100", value: "Nifty 100" },
    { title: "Nifty 200", value: "Nifty 200" },
    { title: "Nifty 500", value: "Nifty 500" },
    { title: "NIFTY MIDCAP 100", value: "NIFTY MIDCAP 100" },
    { title: "NIFTY SMLCAP 100", value: "NIFTY SMLCAP 100" },
    { title: "Bank Nifty", value: "Bank Nifty" },
];
export const indicesSubDropDownList = [
    {
        title: "NSE",
        value: "NSE",
        list: [
            { title: "Bank Nifty", value: "Bank Nifty" },
            { title: "Nifty 100", value: "Nifty 100" },
            { title: "Nifty 200", value: "Nifty 200" },
            { title: "Nifty 500", value: "Nifty 500" },
            { title: "Nifty Midcap 100", value: "NIFTY MIDCAP 100" },
            { title: "Nifty Next 50", value: "Nifty Next 50" },
            { title: "Nifty Small-Cap 100", value: "NIFTY SMLCAP 100" },
            { title: "Nifty 50", value: "Nifty 50" },
        ],
    },
    {
        title: "BSE",
        value: "BSE",
        list: [
            { title: "BSE 100", value: "BSE100" },
            { title: "BSE 200", value: "BSE200" },
            { title: "BSE 500", value: "BSE500" },
            { title: "Sensex", value: "Sensex" },
            { title: "BSE Small-Cap", value: "SMLCAP" },
            { title: "BSE Mid-cap", value: "MIDCAP" },
            { title: "BSE Bankex", value: "BANKEX" },
        ],
    },
];
export const DrivingMarketIndexDropDownList = [
    {
        title: "NSE",
        value: "NSE",
        list: [
            { title: "Bank Nifty", value: "Bank Nifty" },
            { title: "Nifty 100", value: "Nifty 100" },
            { title: "Nifty 200", value: "Nifty 200" },
            { title: "Nifty 500", value: "Nifty 500" },
            { title: "Nifty Midcap 100", value: "NIFTY MIDCAP 100" },
            // { title: "Nifty Midcap 50", value: "Nifty Midcap 50" }, removed since no data in multiple sections
            { title: "Nifty Next 50", value: "Nifty Next 50" },
            { title: "Nifty Small-Cap 100", value: "NIFTY SMLCAP 100" },
            { title: "Nifty 50", value: "Nifty 50" },
        ],
    },
    {
        title: "BSE",
        value: "BSE",
        list: [
            { title: "BSE 100", value: "BSE100" },
            { title: "BSE 200", value: "BSE200" },
            { title: "BSE 500", value: "BSE500" },
            { title: "BSE Sensex", value: "SENSEX" },
            { title: "BSE Small-Cap", value: "SMLCAP" },
        ],
    },
    // {
    //   title: "Sector Indices",
    //   value: "Sector Indices",
    //   list: [
    //     {
    //       title: "NSE - Sectoral Indices",
    //       value: "NSE - Sectoral Indices",
    //       list: [
    //         { title: "Nifty Auto", value: "Nifty Auto" },
    //         { title: "Nifty Energy", value: "Nifty Energy" },
    //         { title: "Nifty Bank", value: "Bank Nifty" },
    //         {
    //           title: "Nifty Financial Services",
    //           value: "Nifty Fin Service",
    //         },
    //         { title: "Nifty FMCG", value: "Nifty FMCG" },
    //         { title: "Nifty IT", value: "Nifty IT" },
    //         { title: "Nifty Media", value: "Nifty Media" },
    //         { title: "Nifty Metal", value: "Nifty Metal" },
    //         { title: "Nifty Pharma", value: "Nifty Pharma" },
    //         { title: "Nifty PSU Bank", value: "Nifty PSU Bank" },
    //         { title: "Nifty Realty", value: "Nifty Realty" },
    //         { title: "Nifty Healthcare", value: "NIFTY HEALTHCARE" },
    //         {
    //           title: "Nifty Consumer Durables",
    //           value: "NIFTY CONSR DURBL",
    //         },
    //         { title: "Nifty Oil & Gas", value: "NIFTY OIL AND GAS" },
    //         { title: "Nifty Private Bank", value: "Nifty Private Bank" },
    //       ],
    //     },
    //     {
    //       title: "BSE - Sectoral Indices",
    //       value: "BSE - Sectoral Indices",
    //       list: [
    //         { title: "BSE Auto", value: "AUTO" },
    //         { title: "BSE BANKEX", value: "BANKEX" },
    //         { title: "BSE Capital Goods", value: "BSE CG" },
    //         {
    //           title: "BSE Consumer Durables",
    //           value: "BSE CD",
    //         },
    //         { title: "BSE FMCG", value: "BSEFMC" },
    //         { title: "BSE Healthcare", value: "BSE HC" },
    //         { title: "BSE Industries", value: "INDSTR" },
    //         { title: "BSE IT", value: "BSE IT" },
    //         { title: "BSE Metal", value: "METAL" },
    //         { title: "BSE Oil & Gas", value: "OILGAS" },
    //         { title: "BSE Power", value: "POWER" },
    //         { title: "BSE Realty", value: "REALTY" },
    //       ],
    //     },
    //   ],
    // },
];
export const DrivingMarketIndexTabList = [
    {
        title: "NSE",
        value: "NSE",
        list: [
            { title: "Bank Nifty", value: "Bank Nifty" },
            { title: "Nifty 100", value: "Nifty 100" },
            { title: "Nifty 200", value: "Nifty 200" },
            { title: "Nifty 500", value: "Nifty 500" },
            { title: "Nifty Midcap 100", value: "NIFTY MIDCAP 100" },
            // { title: "Nifty Midcap 50", value: "Nifty Midcap 50" },
            { title: "Nifty Next 50", value: "Nifty Next 50" },
            { title: "Nifty Small-Cap 100", value: "NIFTY SMLCAP 100" },
            { title: "Nifty 50", value: "Nifty 50" },
        ],
    },
    {
        title: "BSE",
        value: "BSE",
        list: [
            { title: "BSE 100", value: "BSE100" },
            { title: "BSE 200", value: "BSE200" },
            { title: "BSE 500", value: "BSE500" },
            { title: "BSE Sensex", value: "Sensex" },
            { title: "BSE Small-Cap", value: "SMLCAP" },
        ],
    },
    // {
    //   title: "NSE - Sectoral Indices",
    //   value: "NSE - Sectoral Indices",
    //   list: [
    //     { title: "Nifty Auto", value: "Nifty Auto" },
    //     { title: "Nifty Energy", value: "Nifty Energy" },
    //     { title: "Nifty Bank", value: "Bank Nifty" },
    //     {
    //       title: "Nifty Financial Services",
    //       value: "Nifty Fin Service",
    //     },
    //     { title: "Nifty FMCG", value: "Nifty FMCG" },
    //     { title: "Nifty IT", value: "Nifty IT" },
    //     { title: "Nifty Media", value: "Nifty Media" },
    //     { title: "Nifty Metal", value: "Nifty Metal" },
    //     { title: "Nifty Pharma", value: "Nifty Pharma" },
    //     { title: "Nifty PSU Bank", value: "Nifty PSU Bank" },
    //     { title: "Nifty Realty", value: "Nifty Realty" },
    //     { title: "Nifty Healthcare", value: "NIFTY HEALTHCARE" },
    //     {
    //       title: "Nifty Consumer Durables",
    //       value: "NIFTY CONSR DURBL",
    //     },
    //     { title: "Nifty Oil & Gas", value: "NIFTY OIL AND GAS" },
    //     { title: "Nifty Private Bank", value: "Nifty Pvt Bank" },
    //   ],
    // },
    // {
    //   title: "BSE - Sectoral Indices",
    //   value: "BSE - Sectoral Indices",
    //   list: [
    //     { title: "BSE Auto", value: "AUTO" },
    //     { title: "BSE BANKEX", value: "BANKEX" },
    //     { title: "BSE Capital Goods", value: "BSE CG" },
    //     {
    //       title: "BSE Consumer Durables",
    //       value: "BSE CD",
    //     },
    //     { title: "BSE FMCG", value: "BSEFMC" },
    //     { title: "BSE Healthcare", value: "BSE HC" },
    //     { title: "BSE Industries", value: "INDSTR" },
    //     { title: "BSE IT", value: "BSE IT" },
    //     { title: "BSE Metal", value: "METAL" },
    //     { title: "BSE Oil & Gas", value: "OILGAS" },
    //     { title: "BSE Power", value: "POWER" },
    //     { title: "BSE Realty", value: "REALTY" },
    //   ],
    // },
];
export const MarketMapIndexDropDownList = [
    {
        title: "NSE",
        value: "NSE",
        list: [
            { title: "Bank Nifty", value: "Bank Nifty" },
            { title: "Nifty 100", value: "Nifty 100" },
            { title: "Nifty 200", value: "Nifty 200" },
            { title: "Nifty 500", value: "Nifty 500" },
            { title: "Nifty Midcap 100", value: "NIFTY MIDCAP 100" },
            // { title: "Nifty Midcap 50", value: "Nifty Midcap 50" },
            { title: "Nifty Next 50", value: "Nifty Next 50" },
            { title: "Nifty Small-Cap 100", value: "NIFTY SMLCAP 100" },
            { title: "Nifty 50", value: "Nifty 50" },
        ],
    },
    {
        title: "BSE",
        value: "BSE",
        list: [
            { title: "BSE 100", value: "BSE100" },
            { title: "BSE 200", value: "BSE200" },
            { title: "BSE 500", value: "BSE500" },
            { title: "BSE Sensex", value: "Sensex" },
            { title: "BSE Small-Cap", value: "SMLCAP" },
            { title: "BSE Mid-cap", value: "MIDCAP" },
            { title: "BSE Bankex", value: "BANKEX" },
        ],
    },
];
export const stockExchange = [
    { title: "BSE", value: EExchangeType.BSE },
    { title: "NSE", value: EExchangeType.NSE },
];
export const weeklistparams = [
    { title: "1D", value: EPeriod.ONE_DAY },
    { title: "1WK", value: EPeriod.ONE_WEEK },
    { title: "1M", value: EPeriod.ONE_MONTH },
    { title: "3M", value: EPeriod.THREE_MONTH },
    { title: "1Y", value: EPeriod.ONE_YEAR },
];
export const pricebuzzerparams = [
    { title: "3D", value: EPricePeriod.THREE_DAY },
    { title: "5D", value: EPricePeriod.FIVE_DAY },
    { title: "7D", value: EPricePeriod.SEVEN_DAY },
    { title: "14D", value: EPricePeriod.FOURTEEN_DAY },
];
export const volumeBuzzerParams = [
    { title: "Today", value: EVolumePeriod.TODAY },
    { title: "This Week", value: EVolumePeriod.THIS_WEEK },
    { title: "This Month", value: EVolumePeriod.THIS_MONTH },
];
export const circuitparams = [
    { title: "Circuit Filter - 2%", value: ECircuitFilter.TWO_PERCENT },
    { title: "Circuit Filter - 5%", value: ECircuitFilter.FIVE_PERCENT },
    { title: "Circuit Filter - 10%", value: ECircuitFilter.TEN_PERCENT },
    { title: "Circuit Filter - 20%", value: ECircuitFilter.TWENTY_PERCENT },
    { title: "No Circuit Filter", value: ECircuitFilter.NO_FILTER },
];
export const performersparams = [
    { title: "1WK", value: EPeriod.ONE_WEEK },
    { title: "1M", value: EPeriod.ONE_MONTH },
    { title: "3M", value: EPeriod.THREE_MONTH },
    { title: "6M", value: EPeriod.SIX_MONTH },
    { title: "1Y", value: EPeriod.ONE_YEAR },
];
export const marketMapWeekList = [
    { title: "1D", eventKey: EPeriod.ONE_DAY },
    { title: "1WK", eventKey: EPeriod.ONE_WEEK },
    { title: "1M", eventKey: EPeriod.ONE_MONTH },
    // { title: "3M", eventKey: EPeriod.THREE_MONTH },  //Discussed with Jay remove for now we implement later
    // { title: "1Y", eventKey: EPeriod.ONE_YEAR },
];
export const sectorPerformanceMaxLength = 11;
export const fiiDiiWeeks = [
    { title: "Daily", eventKey: "daily", value: "daily" },
    { title: "Monthly", eventKey: "monthly", value: "monthly" },
    { title: "Yearly", eventKey: "yearly", value: "yearly" },
];
export var FiiDiiTabsEnum;
(function (FiiDiiTabsEnum) {
    FiiDiiTabsEnum["ALL"] = "ALL";
    FiiDiiTabsEnum["FII_DII_ERROR_STATE"] = "errorState";
    FiiDiiTabsEnum["FII_CASH"] = "fii-Cash";
    FiiDiiTabsEnum["DII_CASH"] = "dii-Cash";
    FiiDiiTabsEnum["FII_FUTURES"] = "fii-Futures";
    FiiDiiTabsEnum["FII_OPTION"] = "fii-Option";
})(FiiDiiTabsEnum || (FiiDiiTabsEnum = {}));
export const fiiDiiTabs = [
    { title: "FII Cash", eventKey: FiiDiiTabsEnum.FII_CASH },
    { title: "DII Cash", eventKey: FiiDiiTabsEnum.DII_CASH },
    { title: "FII Futures", eventKey: FiiDiiTabsEnum.FII_FUTURES },
    { title: "FII Option", eventKey: FiiDiiTabsEnum.FII_OPTION },
];
// Market Map maximum progress-bar numbers
export const maxProgressBarNum = 6;
// MarketMap Bar Graph series data
export const seriesDataObj = [
    {
        y: 0,
        name: "more then -5%",
        subName: "moreThenNegative5",
        color: "#DD504D",
        opacity: 0.5,
        isPositive: false,
    },
    {
        y: 0,
        name: "-5% to -3%",
        subName: "negative5ToNegative3",
        color: "#DD504D",
        opacity: 0.5,
        isPositive: false,
    },
    {
        y: 0,
        name: "-3% to 0%",
        subName: "negative3ToZero",
        color: "#DD504D",
        opacity: 0.5,
        isPositive: false,
    },
    {
        y: 0,
        name: "0% to 3%",
        subName: "zeroToPositive3",
        color: "#51B255",
        opacity: 0.5,
        isPositive: true,
    },
    {
        y: 0,
        name: "3% to 5%",
        subName: "positive3ToPositive5",
        color: "#51B255",
        opacity: 0.5,
        isPositive: true,
    },
    {
        y: 0,
        name: "more then 5%",
        subName: "moreThanPositive5",
        color: "#51B255",
        opacity: 0.5,
        isPositive: true,
    },
];
export const xAxisBarGarph = {
    id: "x-axis-1",
    categories: [
        "<-5%",
        "-5% to -3%",
        "-3% to 0%",
        "0% to 3% ",
        "3% to 5%",
        ">5%",
    ],
    lineWidth: 1,
    offset: 30,
    labels: {
        y: -10,
        style: {
            useHTML: true,
        },
    },
};
export const yAxisBarGraph = {
    min: 0,
    title: {
        text: "",
    },
    labels: {
        enabled: false,
    },
    gridLineWidth: 0,
    gridLineDashStyle: "none",
    gridLineColor: "#fff",
    stackLabels: {
        enabled: true,
        style: {
            fontWeight: "700",
            textShadow: "none",
            opacity: 0.3,
            fontSize: "12px",
            color: "#424242", // || "#727271"
        },
    },
};
export const EquityNavigation = [
    { category: "", key: "liveIpos" },
    { category: "", key: "marketToday" },
    { category: "Indices High/Low", key: "indices" },
    { category: "Advance/Decline", key: "declines" },
    { category: "Market Map", key: "marketMap" },
    { category: "Sectoral Performance", key: "sectoralPerformance" },
    { category: "Recommendations ", key: "recommendations" },
    { category: "FII and DII Activity", key: "flldllactivity" },
    {
        category: "Insider Trading and SAST",
        key: "insiderTradingAndSast",
    },
    { category: "", key: "equityMarketNews" },
    { category: "Stocks Under Survelliance", key: "stocksUnderSurveillanceWrap" },
    { category: "Events Calendar", key: "eventsCalendar" },
    { category: "WDTM - Top Gainers", key: "top_gainers" },
    { category: "WDTM - Top Losers", key: "top_losers" },
    { category: "WDTM - All Time High", key: "alltime_high" },
    { category: "WDTM - All Time Low", key: "alltime_low" },
    { category: "WDTM - 52 Week High", key: "week_high" },
    { category: "WDTM - 52 Week Low", key: "week_low" },
    { category: "WDTM - Price Buzzers", key: "price_buzzers" },
    { category: "WDTM - Volume Buzzers", key: "volume_buzzers" },
    { category: "WDTM - Upper Circuit", key: "upper_circuit" },
    { category: "WDTM - Lower Circuit", key: "lower_circuit" },
    { category: "WDTM - Index Pullers", key: "index_pullers" },
    { category: "WDTM - Index Dragers", key: "index_draggers" },
    { category: "WDTM - Outperformers", key: "outer_performers" },
    { category: "WDTM - Underperformers", key: "under_performers" },
];
export var EFutureRec;
(function (EFutureRec) {
    EFutureRec["Stock_Futures"] = "Stock Futures";
    EFutureRec["Index_Futures"] = "Index Futures";
})(EFutureRec || (EFutureRec = {}));
export const futurerecommendationparams = [
    { title: "Stock Futures", value: EFutureRec.Stock_Futures },
    { title: "Index Futures", value: EFutureRec.Index_Futures },
];
export const sortlist = {
    "Reported date": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
    Alphabetical: { asc: "Z to A", desc: "A to Z" },
    "Client Name": { asc: "Z to A", desc: "A to Z" },
    // Quantity: { asc: "Lowest to Highest", desc: "Highest to Lowest" },
};
export const sortInsiderTabs = [
    new SortData("Alphabetical", "discriptionName", ESortOrder.DESC),
    new SortData("Reported date", "reportDate", ESortOrder.DESC),
    new SortData("Client Name", "clientName", ESortOrder.UNCHANGED),
    // new SortData("Quantity", "noOfShares", ESortOrder.UNCHANGED),
];
export const DrivingviewallDropList = [
    { title: "1 Day", value: EPeriod.ONE_DAY },
    { title: "1 Week", value: EPeriod.ONE_WEEK },
    { title: "1 Month", value: EPeriod.ONE_MONTH },
];
export const equityRouteConstant = {
    mktEqty: marketsRoute.markets + "/" + MarketTabsConstants.Equity,
};
export const equityViewallRouteConstant = {
    mktEqtyViewall: equityRouteConstant.mktEqty + viewInDetail.viewall,
};
export const EequityRoutes = {
    Advances_Declines: equityViewallRouteConstant.mktEqtyViewall + "/advances-declines",
    Insider: equityViewallRouteConstant.mktEqtyViewall + "/insider",
    FII_DII: equityViewallRouteConstant.mktEqtyViewall + "/fiidii",
    Top_Losers: equityViewallRouteConstant.mktEqtyViewall + "/top-losers",
    Top_Gainers: equityViewallRouteConstant.mktEqtyViewall + "/top-gainers",
    Index_Pullers: equityViewallRouteConstant.mktEqtyViewall + "/index-pullers",
    Index_Draggers: equityViewallRouteConstant.mktEqtyViewall + "/index-draggers",
    All_Time_High: equityViewallRouteConstant.mktEqtyViewall + "/alltime-high",
    All_Time_Low: equityViewallRouteConstant.mktEqtyViewall + "/alltime-low",
    Recommendations: equityViewallRouteConstant.mktEqtyViewall + "/recommendations",
    Week_High: equityViewallRouteConstant.mktEqtyViewall + "/week-high",
    Week_Low: equityViewallRouteConstant.mktEqtyViewall + "/week-low",
    Price_Buzzers: equityViewallRouteConstant.mktEqtyViewall + "/price-buzzers",
    Volume_Buzzers: equityViewallRouteConstant.mktEqtyViewall + "/volume-buzzers",
    Upper_Circuit: equityViewallRouteConstant.mktEqtyViewall + "/upper-circuit",
    Lower_Circuit: equityViewallRouteConstant.mktEqtyViewall + "/lower-circuit",
    Out_Performers: equityViewallRouteConstant.mktEqtyViewall + "/outperformers",
    Under_Performers: equityViewallRouteConstant.mktEqtyViewall + "/underperformers",
    Stocks_Surveillance: equityViewallRouteConstant.mktEqtyViewall + "/stocksundersurveillance",
    Indices: equityViewallRouteConstant.mktEqtyViewall + "/indices",
    MarketMap: equityViewallRouteConstant.mktEqtyViewall + "/marketmap",
};
export const equityRoutes = [
    { title: "Advances/Declines", link: EequityRoutes.Advances_Declines },
    { title: "Insider Trading & SAST", link: EequityRoutes.Insider },
    { title: "FII and DII Activity", link: EequityRoutes.FII_DII },
    { title: "Top Losers", link: EequityRoutes.Top_Losers },
    { title: "Top Gainers", link: EequityRoutes.Top_Gainers },
    { title: "Index Pullers", link: EequityRoutes.Index_Pullers },
    { title: "Index Draggers", link: EequityRoutes.Index_Draggers },
    { title: "All Time High", link: EequityRoutes.All_Time_High },
    { title: "All Time Low", link: EequityRoutes.All_Time_Low },
    { title: "Recommendations", link: EequityRoutes.Recommendations },
    { title: "52 Week High", link: EequityRoutes.Week_High },
    { title: "52 Week Low", link: EequityRoutes.Week_Low },
    { title: "Price Buzzers", link: EequityRoutes.Price_Buzzers },
    { title: "Volume Buzzers", link: EequityRoutes.Volume_Buzzers },
    { title: "Upper Circuit", link: EequityRoutes.Upper_Circuit },
    { title: "Lower Circuit", link: EequityRoutes.Lower_Circuit },
    { title: "Out Performers", link: EequityRoutes.Out_Performers },
    { title: "Underperformers", link: EequityRoutes.Under_Performers },
    {
        title: "Stocks Under Surveillance",
        link: EequityRoutes.Stocks_Surveillance,
    },
    { title: "Indices High/Low", link: EequityRoutes.Indices },
    { title: "Market Map", link: EequityRoutes.MarketMap },
];
